"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={ref} className="relative overflow-hidden bg-gradient-to-br from-background via-background to-red-50/20 py-20 md:py-28 lg:py-36">
      <div className="container mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          
          {/* CONTENIDO DE TEXTO */}
          <div className={`flex flex-col gap-8 transition-all duration-700 ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {/* H1: Fast & Reliable Water Pump Solutions */}
            <h1 className="font-display text-5xl font-bold leading-[1.1] text-foreground md:text-6xl lg:text-7xl tracking-tight">
              Fast & Reliable{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-red-400 to-red-600">
                Water Pump Solutions
              </span>
            </h1>
            
            <div className={`transition-all duration-700 delay-100 ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <p className="font-display text-3xl md:text-4xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-red-600 to-red-700">
                AA Eagle Plumbing
              </p>
            </div>
            
            <p className="text-lg text-foreground/80 md:text-xl lg:text-2xl leading-relaxed font-sans">
              Your trusted experts in water pump servicing for commercial and residential properties. Specializing in booster pumps, sewage lift stations, submersible pumps, and line-shaft turbines. From installation and maintenance to emergency repairs and motor rewinds, we deliver fast, reliable water pump solutions you can depend on.
            </p>
            
            <div className={`transition-all duration-700 delay-200 ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <Button asChild size="lg" className="bg-gradient-to-r from-red-500 via-red-600 to-red-700 text-white shadow-strong hover:shadow-[0_12px_40px_rgba(220,38,38,0.4)] hover:-translate-y-1 active:translate-y-0 transition-all duration-300 ease-[var(--ease-spring)] rounded-xl px-8 py-6 text-base font-bold tracking-wide hover:scale-105">
                <Link to="/ContactPage">Request Free Estimate</Link>
              </Button>
            </div>
          </div>

          {/* IMAGEN Y EFECTOS */}
          <div className={`relative flex items-center justify-center lg:justify-end transition-all duration-700 delay-300 ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative w-full max-w-lg">
              {/* Glow effect detrás de la imagen */}
              <div className="absolute inset-0 bg-gradient-to-tr from-red-500/20 via-red-400/20 to-red-600/20 rounded-2xl blur-2xl opacity-60 animate-pulse" />

              <div className="relative overflow-hidden rounded-2xl shadow-strong border-2 border-red-500/30 hover:border-red-500/50 transition-all duration-500 ease-[var(--ease-smooth)] hover:shadow-[0_20px_60px_rgba(220,38,38,0.3)] hover:-translate-y-2 group">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/commercial_water_pump_system_installation.png" alt="Commercial water pump system installation" className="h-auto w-full object-cover transition-transform duration-700 ease-[var(--ease-smooth)] group-hover:scale-105" />
                {/* Overlay sutil en hover */}
                <div className="absolute inset-0 bg-gradient-to-tr from-red-500/15 via-transparent to-red-600/15 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}